import apiClient from '../axios';

// Interfaces
export interface ApiResponse<T> {
  responseValue: T;
  statusCode: number;
  message: string;
}

export interface CategorySet {
  name: string;
  language: string;
}

export interface CategoryDto {
  id: number;
  isActive: boolean;
  parentCategoryDto: CategoryDto | null;
  categorySetsDtos: CategorySet[];
  name?: string;
}

export interface Category {
  id: number;
  name: string;
  parentId?: number | null;
  isActive?: boolean;
  children?: Category[];
}

export interface GetUpperCategoriesRequest {
  SearchTerm?: string;
}

export interface GetUpperCategoriesResponse extends Array<CategoryDto> {}

export interface GetAllCategoriesRequest {
  SearchTerm?: string;
}

export interface GetAllCategoriesResponse extends Array<CategoryDto> {}

export const categoryService = {
  // Get upper categories
  async getUpperCategories(data: GetUpperCategoriesRequest = {}): Promise<ApiResponse<GetUpperCategoriesResponse>> {
    const params = new URLSearchParams();
    
    if (data.SearchTerm) {
      params.append('SearchTerm', data.SearchTerm);
    }

    const response = await apiClient.get('/Categories/category/get-upper-categories', {
      params
    });
    
    return response.data;
  },

  // Get all categories
  async getAllCategories(data: GetAllCategoriesRequest = {}): Promise<ApiResponse<GetAllCategoriesResponse>> {
    const params = new URLSearchParams();
    
    if (data.SearchTerm) {
      params.append('SearchTerm', data.SearchTerm);
    }

    const response = await apiClient.get('/Categories/category/get-all', {
      params
    });
    
    return response.data;
  }
};

export default categoryService;
